/**
 * @description Animation au scroll
 */

(() => {
	/**
	 * @description La class-selector est à définir côté twig
	 * @constant scrollElements Global Anime selector
	 */
	const scrollElements = document.querySelectorAll('.js-scroll') || null;
	const menuItems =
		document.querySelectorAll<HTMLElement>('.menu > .menu-item') || null;
	const svgAnimated =
		document.querySelectorAll<HTMLElement>('[data-pattern]') || null;
	const shortcuts =
		document.querySelector<HTMLElement>('.hp-quick-access__list') || null;
	const news = document.querySelector<HTMLElement>('.hp-news') || null;
	const events = document.querySelector<HTMLElement>('.hp-agenda') || null;
	const kioskNewsletter =
		document.querySelector<HTMLElement>('.hp-kiosk-newsletter') || null;
	const hpCta = document.querySelector<HTMLElement>('.hp-cta') || null;
	const hpSocials =
		document.querySelector<HTMLElement>('.hp-social__list') || null;
	const gutenbergMainContent =
		document.querySelector<HTMLElement>('.gutenberg-main-content') || null;
	/**
	 * @description Détection lorsqu'un élément est en vue
	 * @param {*} el Element - "class-selector"
	 * @param {*} divH Définit la hauteur de l'élément au moment ou l'anime est déclenchée
	 * @method getBoundingClientRect Méthode permettant d'obtenir la distance d'un élément par rapport au haut de la page
	 * @property {number} innerHeight Permet de récupèrer la hauteur de la fenêtre
	 * @returns L'élément au moment du scroll
	 */
	const elementInView = (el: HTMLElement, divH: any = 1) => {
		const elementTop = el.getBoundingClientRect().top;
		return (
			elementTop <=
			(window.innerHeight || document.documentElement.clientHeight) / divH
		);
	};

	/**
	 * @description Détection lorsqu'un élément est en dehors de la vue
	 * @param {*} el Element
	 * @return {*} Permet de déclencher à nouveau l'anime quand l'élément est déjà scrollé
	 */
	const elementOutofView = (el: HTMLElement): any => {
		const elementTop = el.getBoundingClientRect().top;

		return (
			elementTop >
			(window.innerHeight || document.documentElement.clientHeight)
		);
	};

	/**
	 * @description Ajoute la class "scrolled" lorsque l'élément est dans la vue
	 */
	const displayScrollElement = (element: HTMLElement) => {
		element.classList.add('scrolled');
	};

	/**
	 * @description Retire la class "scrolled" lorsque l'élément n'est plus dans la vue
	 * Cela permet de re-déclencher l'animation lorsque l'élément sera à nouveau scrollé
	 */
	const hideScrollElement = (element: HTMLElement) => {
		element.classList.remove('scrolled');
	};

	/**
	 * @description Déclencheur au scroll
	 * La seule chose à modifier ici est le second paramétre "divH" :
	 * À ajuster pour déclencher l'event au moment voulu lors du scroll.
	 * Le fait de boucler la/les "class-selector" permet d'appliquer
	 * les différentes méthodes sur l'ensemble des éléments
	 * Si cas specifique on check si classe existe et on applique sa popote
	 * sinon on ajoute la casse souhaitée dans le tableau items
	 * @example La condition pour chaque "class-selector" est importante pour éviter un cas d'erreur
	 */
	const handleScrollAnimation = () => {
		//Classe de  base
		if (scrollElements) {
			scrollElements.forEach((el: HTMLElement) => {
				if (elementInView(el)) {
					displayScrollElement(el);
				} else if (elementOutofView(el)) {
					hideScrollElement(el);
				}
			});
		}

		//Animations des items du menu
		if (menuItems) {
			menuItems.forEach((item) => {
				if (elementInView(item, 1.5)) {
					if (elementInView(item, 2.2)) {
						for (let i = 0; i < menuItems.length; i++) {
							//@ts-ignore
							fadeIn(menuItems[i], i * 200);
						}
					} else if (elementOutofView(item)) {
						hideScrollElement(item);
					}
				}
			});
		}
		//Animations des svf
		if (svgAnimated) {
			svgAnimated.forEach((svg) => {
				if (elementInView(svg)) {
					displayScrollElement(svg);
				} else if (elementOutofView(svg)) {
					hideScrollElement(svg);
				}
			});
		}
		//Animation spé shortcuts
		if (shortcuts) {
			const shortcutsItems = shortcuts.querySelectorAll(
				'.hp-quick-access__list__item'
			);
			if (elementInView(shortcuts, 1.2)) {
				for (let i = 0; i < shortcutsItems.length; i++) {
					//@ts-ignore
					fadeIn(shortcutsItems[i], i * 150);
				}
			}
		}
		// Animation Gugutenberg

		if (gutenbergMainContent) {
			// Animations wp-blocks
			const wpBlocks =
				gutenbergMainContent.querySelectorAll('[class^="wp-block-"]') ||
				null;
			if (wpBlocks) {
				wpBlocks.forEach((bloc) => {
					const el = bloc as HTMLElement;
					if (elementInView(el, 0)) {
						displayScrollElement(el);
					} else if (elementOutofView(el)) {
						hideScrollElement(el);
					}
				});
			}
			// Animations paragraph
			const gutenbergParagraph =
				gutenbergMainContent.querySelectorAll('p') || null;
			if (gutenbergParagraph) {
				gutenbergParagraph.forEach((p) => {
					const el = p as HTMLElement;
					if (elementInView(el, 0)) {
						displayScrollElement(el);
					} else if (elementOutofView(el)) {
						hideScrollElement(el);
					}
				});
			}

			// Animations Listes
			const gutenbergList =
				gutenbergMainContent.querySelectorAll('ul') || null;
			if (gutenbergList) {
				gutenbergList.forEach((ul) => {
					const el = ul as HTMLElement;
					el.classList.add('animate-ul');
					if (elementInView(el, 0)) {
						displayScrollElement(el);
					} else if (elementOutofView(el)) {
						hideScrollElement(el);
					}
				});
			}
			// Animations trombi
			const blocTrombi =
				gutenbergMainContent.querySelectorAll('.trombinoscope__item') ||
				null;
			if (blocTrombi) {
				blocTrombi.forEach((bloc, index) => {
					const el = bloc as HTMLElement;
					if (elementInView(el, 1.5)) {
						//@ts-ignore
						fadeIn(blocTrombi[index], index * 100);
					} else if (elementOutofView(el)) {
						hideScrollElement(el);
					}
				});
			}
			// Animations block Kiosque
			const kioskBlocks =
				gutenbergMainContent.querySelectorAll('.kiosk-documents') ||
				null;
			if (kioskBlocks) {
				kioskBlocks.forEach((bloc, index) => {
					const el = bloc as HTMLElement;
					if (elementInView(el, 1.5)) {
						//@ts-ignore
						fadeIn(kioskBlocks[index], index * 100);
					} else if (elementOutofView(el)) {
						hideScrollElement(el);
					}
				});
			}
		}

		// Animation avec déclenchement et process  classiques
		const items = [
			{ element: news, viewFactor: 1.5 },
			{ element: events, viewFactor: 1 },
			{ element: kioskNewsletter, viewFactor: 0 },
			{ element: hpCta, viewFactor: 1 },
			{ element: hpSocials, viewFactor: 1 },
		];

		items.forEach((scrollElement) => {
			const element = scrollElement.element;
			const viewFactor = scrollElement.viewFactor;

			if (element) {
				if (elementInView(element, viewFactor)) {
					displayScrollElement(element);
				} else if (elementOutofView(element)) {
					hideScrollElement(element);
				}
			}
		});
	};

	/**
	 * @description Animation prefaite de fade In
	 * @param item HTMLElement à cibler
	 * @param delay: Number-> gère le délai en ms
	 *
	 */
	const fadeIn = (item: HTMLElement, delay: number) => {
		setTimeout(() => {
			item.classList.add('fadeIn');
		}, delay);
	};

	// Event au scroll et au load 🚀

	const listeners = ['scroll', 'load'];
	for (let i = 0; i < listeners.length; i++) {
		window.addEventListener(listeners[i], () => {
			handleScrollAnimation();
            console.log('toto')
		});
	}
})();
